var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"min_h"},[_c('div',{staticClass:"text"},[_vm._v("订单支付中...")]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}})]),_c('div',{staticClass:"tip_copyright"},[_vm._v("本系统已获软件著作权，受《中华人民共和国著作权法》和《计算机软件保护条例》的保护，未经许可请勿擅自使用、复制、传播软件。")])])
}
var staticRenderFns = []

export { render, staticRenderFns }